import Cookies from 'universal-cookie';

import { trans, useSoyuzLocales } from '@spotahome/soyuz/client';

import Dropdown from '../Dropdown';

import DropdownItem from '../DropdownItem';

import { DSIcon } from '../../../base';

import {
  useAvailableLocales,
  useLocaleProviderChange
} from '../../context/LocaleContext';

import Link from '../Link';

const LanguageSwitcher = () => {
  const { current } = useSoyuzLocales();
  const onChange = useLocaleProviderChange();
  const supportedLocales = useAvailableLocales();

  const setLocaleCookie = selectedLocale => {
    const cookies = new Cookies();
    const options = { path: '/', maxAge: 2628000 }; // expires after one month
    return cookies.set('locale', selectedLocale, options);
  };

  const handlerOnChange = event => {
    const selectedLocale = event.target.value;
    setLocaleCookie(selectedLocale);
    onChange(selectedLocale, current);
  };

  return (
    <Dropdown
      title={
        <>
          <DSIcon name="language" /> <div>{current}</div>
        </>
      }
      position="right"
      color="light"
      itemsColor="light-redesign"
      textTransform="capitalize"
      disableHover
      roundedBorders
      className="menu-white-redesign"
      arrowIcon
    >
      {supportedLocales.sort().map(locale => (
        <DropdownItem key={locale} inline>
          <Link href="#" onClick={() => handlerOnChange(locale)}>
            {trans(`locale.${locale}`)}
          </Link>
        </DropdownItem>
      ))}
    </Dropdown>
  );
};

export default LanguageSwitcher;
